export default __webpack_public_path__ + "static/media/4.0a11d663.jpeg";